import React from "react";
import PropTypes from "prop-types";
import { Icons } from "@learningblocks/exp-constants";

const {
  SearchMagnifyPlus: SearchAddIcon,
  SearchMagnifyMinus: SearchSubtractIcon,
} = Icons;
export function ZoomInIcon(props) {
  return <SearchAddIcon className={props.className} style={{ fill: "none" }} />;
}

ZoomInIcon.propTypes = {
  /**
   * ClassName to be set on the component
   */
  className: PropTypes.string,
};

export function ZoomOutIcon(props) {
  return (
    <SearchSubtractIcon className={props.className} style={{ fill: "none" }} />
  );
}

ZoomOutIcon.propTypes = ZoomInIcon.propTypes;
